import { render } from "./KioskBooking.vue?vue&type=template&id=360c32a6&scoped=true"
import script from "./KioskBooking.vue?vue&type=script&lang=js"
export * from "./KioskBooking.vue?vue&type=script&lang=js"

import "./KioskBooking.vue?vue&type=style&index=0&id=360c32a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360c32a6"]])

export default __exports__